<template>
    <div class="layout">
        <div class="row">
            <div class="col-xs-12">
                <img width="100%" :src="srcImage" alt="Vista previa">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        file: {
            required: true
        }
    },
    mounted: function () {
        this.srcImage = URL.createObjectURL(this.file);
    },
    data: function () {
        return {
            srcImage: ''
        };
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/ImageViewer.vue